/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  GetInfo12PathParameters,
  List22Params,
  Remove14PathParameters,
  TableDataInfo,
  TravelTouristPreference
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 修改游客喜好
 */
const edit2 = (
    travelTouristPreference: TravelTouristPreference,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/preference`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: travelTouristPreference
    },
      );
    }
  /**
 * @summary 获取游客喜好详情
 */
const getInfo12 = (
    { preferenceId }: GetInfo12PathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/preference/${preferenceId}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 查询游客喜好列表
 */
const list22 = (
    params: List22Params,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/preference/list`, method: 'GET',
        params
    },
      );
    }
  /**
 * @summary 删除游客喜好
 */
const remove14 = (
    { preferenceIds }: Remove14PathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/preference/${preferenceIds}`, method: 'DELETE'
    },
      );
    }
  return {edit2,getInfo12,list22,remove14}};
export type Edit2Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['edit2']>>>
export type GetInfo12Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['getInfo12']>>>
export type List22Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['list22']>>>
export type Remove14Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['remove14']>>>
